'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _class, _class2, _temp;

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _Detail = require('./Detail.scss');

var _Detail2 = _interopRequireDefault(_Detail);

var _reactIntl = require('react-intl');

var _trip = require('utils/trip');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
  Detail: {
    displayName: 'Detail'
  }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/TripDetail/Detail.js',
  components: _components,
  locals: [],
  imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
  return function (Component) {
    return _reactTransformCatchErrors2(Component, id);
  };
}

var Detail = _wrapComponent('Detail')((_dec = (0, _reactCssModules2.default)(_Detail2.default), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Detail, _Component);

  function Detail() {
    (0, _classCallCheck3.default)(this, Detail);
    return (0, _possibleConstructorReturn3.default)(this, (Detail.__proto__ || (0, _getPrototypeOf2.default)(Detail)).apply(this, arguments));
  }

  (0, _createClass3.default)(Detail, [{
    key: 'render',
    value: function render() {
      var trip = this.props.trip;

      var transportation = (0, _trip.getTransportation)(trip.transportation);
      return _react3.default.createElement(
        'div',
        null,
        _react3.default.createElement(
          'h2',
          { styleName: 'sub-header' },
          _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.body.trip_detail.label' })
        ),
        _react3.default.createElement(
          'div',
          { styleName: 'activities' },
          _react3.default.createElement(
            'div',
            { styleName: 'activities-label' },
            _react3.default.createElement('i', { styleName: 'transportation-icon' }),
            _react3.default.createElement(
              'span',
              null,
              _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.body.trip_detail.transportation.label' }),
              ' :'
            )
          ),
          _react3.default.createElement(
            'div',
            { styleName: 'activities-detail' },
            _react3.default.createElement(
              'p',
              null,
              transportation.standard ? _react3.default.createElement(_reactIntl.FormattedMessage, { id: transportation.id }) : transportation.id
            )
          )
        ),
        _react3.default.createElement(
          'div',
          { styleName: 'activities' },
          _react3.default.createElement(
            'div',
            { styleName: 'activities-label' },
            _react3.default.createElement('i', { styleName: 'max-travelers-icon' }),
            _react3.default.createElement(
              'span',
              null,
              _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.body.trip_detail.max_tr.label' }),
              ' :'
            )
          ),
          _react3.default.createElement(
            'div',
            { styleName: 'activities-detail' },
            _react3.default.createElement(
              'p',
              null,
              trip.max_travelers
            )
          )
        ),
        trip.intermediate_locations && trip.intermediate_locations.length > 0 && _react3.default.createElement(
          'div',
          { styleName: 'activities' },
          _react3.default.createElement(
            'div',
            { styleName: 'activities-label' },
            _react3.default.createElement('i', { styleName: 'stop-icon' }),
            _react3.default.createElement(
              'span',
              null,
              _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.body.trip_detail.stopped_by.label' }),
              ' :'
            )
          ),
          _react3.default.createElement(
            'div',
            { styleName: 'activities-detail' },
            _react3.default.createElement(
              'p',
              null,
              trip.intermediate_locations.join(', ')
            )
          )
        ),
        _react3.default.createElement(
          'div',
          { styleName: 'activities' },
          _react3.default.createElement(
            'div',
            { styleName: 'activities-label' },
            _react3.default.createElement('i', { styleName: 'language-icon' }),
            _react3.default.createElement(
              'span',
              null,
              _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.body.trip_detail.language.label' }),
              ' :'
            )
          ),
          _react3.default.createElement(
            'div',
            { styleName: 'activities-detail' },
            _react3.default.createElement(
              'p',
              null,
              trip.languages.join(', ')
            )
          )
        ),
        trip.conditions && trip.conditions.length > 0 && _react3.default.createElement(
          'div',
          { styleName: 'activities-condition' },
          _react3.default.createElement(
            'div',
            { styleName: 'activities-label', style: { width: '100%' } },
            _react3.default.createElement('i', { styleName: 'condition-icon' }),
            _react3.default.createElement(
              'span',
              null,
              _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.body.trip_detail.condition.label' })
            )
          ),
          trip.conditions.map(function (condition, i) {
            return _react3.default.createElement(
              'div',
              { styleName: 'activities-condition-label', key: i },
              _react3.default.createElement('i', { styleName: (0, _trip.getCondition)(condition).icon }),
              _react3.default.createElement(
                'span',
                null,
                _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.body.trip_detail.' + condition + '.label' })
              )
            );
          })
        )
      );
    }
  }]);
  return Detail;
}(_react2.Component), _class2.propTypes = {
  trip: _react2.PropTypes.object
}, _temp)) || _class));

exports.default = Detail;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TripDetail/Detail.js
// module id = 1630
// module chunks = 0